"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bulkUpdateAnalysisResultsOutputDtoSchema = exports.bulkUpdateAnalysisResultsInputDtoSchema = void 0;
const zod_1 = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const zod_preprocessors_js_1 = require("../utils/zod-preprocessors.js");
const bulkUpdateAnalysisResultsInput = {
    ids: zod_1.z.array(zod_1.z.string()),
    statusOverride: sigma_engine_shared_1.RequirementInstanceResultOverrideStatusSchema.nullable().optional(),
    isReviewed: zod_1.z.boolean().optional(),
};
exports.bulkUpdateAnalysisResultsInputDtoSchema = zod_1.z.object(bulkUpdateAnalysisResultsInput);
const bulkUpdateAnalysisResultsOutput = {
    results: zod_1.z.array(zod_1.z.preprocess(zod_preprocessors_js_1.preprocessResult, sigma_engine_shared_1.RequirementInstanceResultSchema)),
};
exports.bulkUpdateAnalysisResultsOutputDtoSchema = zod_1.z.object(bulkUpdateAnalysisResultsOutput);
//# sourceMappingURL=bulk-update-analysis-results.dto.js.map